// @flow
import * as React from 'react';
import { get } from 'lodash';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import SectionBlocks from 'Components/widgets/section-blocks/SectionBlocks.jsx';

type Props = {
  sections: string,
};

class Sections extends React.Component<Props> {
  renderSection(section: {}, index: number) {
    return (
      <div key={index} className="Line">
        <SiteContainer>
          <SectionBlocks
            allBlocks={section}
            trackingData={{
              actionGA: 'push_content',
              labelGA: `sections.${index + 1}`,
            }}
          />
        </SiteContainer>
      </div>
    );
  }

  render() {
    const parsedProps = JSON.parse(get(this.props, 'sections', '[]'));
    return parsedProps.length > 0 ? <div> {parsedProps.map(this.renderSection)}</div> : null;
  }
}

export default Sections;
